import { SVGProps } from 'react';

export default function EvaporatorCoilIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 24 24'
      strokeWidth={1.5}
      stroke='currentColor'
      aria-hidden='true'
      {...props}
    >
      <rect x='5.25' y='3' width='13.5' height='18' rx='1.5' />
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M8.25 17.25 12 7.5l3.75 9.75M7.5 17.25h9M10.6 11.6h2.8M9.6 14.4h4.8'
      />
    </svg>
  );
}
